import { render } from "./McpIcon.vue?vue&type=template&id=bbcd5688"
import script from "./McpIcon.vue?vue&type=script&lang=js"
export * from "./McpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__